import React from "react";
import ItemHandlingList from "../../items/item-handling-list";

/**
 * Report-specific wrapper for ItemHandlingList
 * This component uses the generic ItemHandlingList component
 */
const ReportItemHandlingList = ({ itemList, isLoading = false }) => {
  return (
    <ItemHandlingList 
      itemList={itemList} 
      isLoading={isLoading} 
      moduleType="report"
    />
  );
};

export default ReportItemHandlingList;

